module.exports = __webpack_public_path__ + "media/images/index/tumbup-1ab455569589b4fd24c9fcbb325b2c63.svg";